module.exports = __webpack_public_path__ + "coin_RIPPLE.png?77508cc6cabdb53658279ea2adc14926";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_RIPPLE.png
// module id = 1113
// module chunks = 2